<template>
  <div>
    <file-view :editable="false" :show-file="true" accept=".pdf, image/*" :attachId="attachId"  />
  </div>
</template>

<script>
import FileView from "./class/fileView";
export default {
  components: {
    FileView
  },
  props: {
  },
  data: () => ({
    attachId: null
  }),
  computed: {
  },

  created() {
    if (this.$route.params.attachId) {
      this.attachId = this.$route.params.attachId;
    }

  },

  methods: {
  },
};
</script>
